import { Box, Dialog, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as SuccessIcon } from 'assets/rca_generation_success.svg';
import { ReactComponent as FailedIcon } from 'assets/rca_generation_warning.svg';

interface RcaStatusModalProps {
  open: boolean;
  onClose: () => void;
  status: 'success' | 'failed' | null;
  incidentId: string;
  onReviewClick?: () => void;
}

const RcaStatusModal = ({ open, onClose, status, incidentId, onReviewClick }: RcaStatusModalProps) => {
  if (!status) return null;

  const isSuccess = status === 'success';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 0,
          border: '1px solid #009CDE',
        }
      }}
    >
      <Box
        sx={{
          backgroundColor: '#043B72',
          color: '#ffffff',
          px: 3,
          py: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {isSuccess ? 'RCA Generation Success' : 'RCA Generation Failed'}
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ color: '#ffffff' }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          backgroundColor: '#EBF3FE',
          px: 3,
          py: 4,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
          <Box
            sx={{
              width: '76px',
              height: '76px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {isSuccess ? <SuccessIcon width={60} height={72} /> : <FailedIcon width={76} height={66} />}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#000000' }}>
              {isSuccess
                ? `RCA generated successfully for Incident Id `
                : `RCA generated failed for Incident Id `}
              <Box component="span" sx={{ textDecoration: 'underline' }}>
                {incidentId}
              </Box>
            </Typography>
            <Typography sx={{ color: '#333333' }}>
              {isSuccess ? (
                <>
                  Click to <Box component="span" onClick={onReviewClick} sx={{ color: '#00A3E0', textDecoration: 'underline', cursor: 'pointer' }}>Review</Box>
                </>
              ) : (
                'Please try again.'
              )}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Button
            variant="contained"
            onClick={onClose}
            disableElevation
            sx={{
              backgroundColor: '#009CDE',
              color: '#ffffff',
              borderRadius: '4px',
              px: 4,
              '&:hover': {
                backgroundColor: '#008CBE',
              }
            }}
          >
            CLOSE
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default RcaStatusModal;
